import { Resume } from 'packages/types'
import {
  ColorChangeHandler,
  FontChangeHandler,
  LayoutFormatChangeHandler,
  SettingsFieldChangeHandler,
  SizeChangeHandler,
  SpacingChangeHandler,
  TemplateChangeHandler,
} from 'builder/modules/resumeEditor'

export interface TemplateCustomizationSheetProps {
  onClose: () => void
  resume: Resume
  updateTemplate: TemplateChangeHandler
  handleColorSelect: ColorChangeHandler
  handleFontChange?: FontChangeHandler
  handleChangeLayoutFormat?: LayoutFormatChangeHandler
  handleSpacingChange?: SpacingChangeHandler
  handleSizeChange?: SizeChangeHandler
  handleSettingsFieldChange?: SettingsFieldChangeHandler
}

export enum TabType {
  templates = 'templates',
  text = 'text',
  layout = 'layout',
}

export interface Tab {
  label: React.ReactElement
  id: TabType
  content: React.ReactElement
}
